module.exports = __webpack_public_path__ + "li.319a774214f8fe6fcd8b.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/li.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/li.svg
// module chunks = styles